import { addDays, format } from "date-fns";
import { CalendarPlus, ChevronLeft, ChevronRight, Loader2, Plus, Sparkles } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const iconBtn = "w-10 h-10 rounded-full border border-[#103080]/15 bg-white/70 flex items-center justify-center text-[#103080] hover:bg-[#103080] hover:text-white transition-colors duration-200";
const ghostBtn = "inline-flex items-center gap-2 rounded-full border border-[#103080]/20 bg-white/70 text-[#103080] font-medium px-5 h-11 text-sm hover:border-[#0090D0] hover:text-[#0090D0] transition-colors duration-200";

export default function WeekToolbar(p) {
  const end = addDays(p.weekStart, 6);
  return (
    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 fade-up">
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-[#0090D0] font-semibold mb-3">
          {p.viewUserId ? `Viewing ${p.viewedName}'s week` : "Your week"}
        </p>
        <h1 className="font-serif-brand font-semibold text-[#103080] text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-testid="week-range-title">
          {format(p.weekStart, "d MMM")} <i className="text-[#0090D0]">to</i> {format(end, "d MMM yyyy")}
        </h1>
        <div className="mt-4 flex items-center gap-2">
          <button className={iconBtn} onClick={p.onPrev} data-testid="week-prev-button" aria-label="Previous week"><ChevronLeft size={18} /></button>
          <button className={`${ghostBtn} h-10`} onClick={p.onToday} data-testid="week-today-button">This week</button>
          <button className={iconBtn} onClick={p.onNext} data-testid="week-next-button" aria-label="Next week"><ChevronRight size={18} /></button>
          {p.team.length > 0 && (
            <Select value={p.viewUserId || "me"} onValueChange={(v) => p.onViewUser(v === "me" ? "" : v)}>
              <SelectTrigger className="w-48 h-10 rounded-full bg-white/70 border-[#103080]/20 ml-2" data-testid="view-user-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="me">My schedule</SelectItem>
                {p.team.filter((m) => m.role !== "admin" || m.id !== undefined).map((m) => (
                  <SelectItem key={m.id} value={m.id} data-testid={`view-user-option-${m.id}`}>{m.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button className={ghostBtn} onClick={p.onAddEvent} data-testid="add-event-button"><CalendarPlus size={16} /> Block time</button>
        <button className={ghostBtn} onClick={p.onAddTask} data-testid="add-task-button"><Plus size={16} /> Add task</button>
        <button
          onClick={p.onAutoPlan}
          disabled={p.planning}
          data-testid="auto-schedule-button"
          className="inline-flex items-center gap-2 rounded-full bg-[#103080] text-white font-medium px-6 h-11 text-sm hover:bg-[#0090D0] hover:-translate-y-[1px] transition-[background-color,transform] duration-200 shadow-md disabled:opacity-60"
        >
          {p.planning ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
          Auto-schedule my week
        </button>
      </div>
    </div>
  );
}
